// extracted by mini-css-extract-plugin
module.exports = {"href":"Tab_href__8vXT7","active":"Tab_active__2j_bA"};